import React, { useState, useEffect } from 'react';
import { TextField, Button, Switch, FormControlLabel, FormControl, Box, MenuItem, Select, InputLabel, Typography } from '@mui/material';
import { PlusCircle, ArrowLeft, User, ChevronLeft, MapPin } from 'react-feather';
import { Autocomplete } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { authApi } from '../../api/api';
import Toastmessage from '../../components/Toast';
import { logout } from '../../features/auth/AuthSlice';
import { useDispatch } from 'react-redux'
import { set } from 'date-fns';


export default function EditLocation() {
  const [active, setActive] = useState(true);
  const [locationName, setLocationName] = useState('');
  const [locationAddress, setLocationAddress] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState(null);
  const [country, setCountry] = useState({ id: '', name: '' });
  const [pinCode, setPinCode] = useState('');
  const [errors, setErrors] = useState({}); // State to hold validation errors
  const [locationID, setlocationID] = useState('');
  const [stateOptions, setStateOptions] = useState([]);
  const [isLoading, setIsloading] = useState(false);

  const token = useSelector((state) => state.auth.token); // Get the token from Redux
  const userID = useSelector((state) => state.auth.id); // Get the userID from Redux

  const dispatch = useDispatch()
  const navigate = useNavigate();

  const location = useLocation();
  const { locationId } = location.state || {}; // Retrieve the ID


  useEffect(() => {
    if (locationId) {
      setlocationID(locationId);
      editLocation(locationId); // Call editLocation directly with the id
      listStates();
    }
  }, [locationId]); // Only runs when locationId changes, so editLocation is called once.

  const listStates = async () => {
    const input_token = 'STATES'; // Replace with your actual token
    const apiUrl = 'list_of_states'; // Replace with the actual API endpoint

    const dataInput = {
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);

      if (data && data.success) {
        const statesArray = data.list_of_states.map(state => ({
          id: state.id,
          name: state.state_name,
          shortCode: state.state_short_code
        }));

        setStateOptions(statesArray);
      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  }

  const editLocation = async (id) => {
    if (!id) return; // Ensure locationID is available

    const input_token = id; // Replace with your actual token
    const apiUrl = 'view_location'; // Replace with the actual API endpoint

    const dataInput = {
      location_id: id,
      login_user_id: userID
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);
      setLocationName(data.locations.location_name);
      setLocationAddress(data.locations.address);
      setLocationAddress(data.locations.address);

      // Set state using the country data from API response
      if (data.locations.country) {
        const apiCountry = {
          name: data.locations.country
        };
        setCountry(apiCountry); // Set the state as an object matching the structure in stateOptions
      }

      // Set state using the state data from API response
      if (data.locations.states) {
        const apiState = {
          id: data.locations.states.id,
          name: data.locations.states.state_name,
        };
        setState(apiState); // Set the state as an object matching the structure in stateOptions
      }

      setCity(data.locations.city);
      setPinCode(data.locations.zip_code);

      // Active & Inactive status
      if (data.locations.status == 1) {
        setActive(true);
      } else {
        setActive(false);
      }

    } catch (error) {
      console.error("Error fetching location data:", error);
    }
  }

  const handleActiveChange = (event) => {
    setActive(event.target.checked);
  };

  const countryOptions = [
    { id: 1, name: 'USA' }
  ];

  const validateForm = () => {
    const newErrors = {};

    if (!locationName.trim()) {
      newErrors.locationName = "Location name is required";
    }

    if (!locationAddress) {
      newErrors.locationAddress = "Location address is required";
    }

    if (!country) {
      newErrors.country = "Country is required";
    }

    if (!state) {
      newErrors.state = "State is required";
    }

    if (!city) {
      newErrors.city = "City is required";
    }

    if (!pinCode) {
      newErrors.pinCode = "Zip code is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();


    if (!validateForm()) {
      return; // Exit if validation fails
    }

    const formData = {
      locationName,
      locationAddress,
      city,
      state,
      country,
      pinCode,
      active,
    };

    // Define the function for the API call
    const fetchData = async () => {
      setIsloading(true);
      const input_token = locationId + 'UPDATE_LOCATION'; // Replace with your actual token
      const apiUrl = 'update_location'; // Replace with the actual API endpoint

      const dataInput = {
        id: locationId,
        login_user_id: userID,
        location_name: locationName,
        state_id: state?.id || 1, // Ensure state has an id, otherwise use default
        city: city,
        zip_code: pinCode,
        country: country.name || country, // Assuming country is an object with a name property
        address: locationAddress,
        status: active ? 1 : 0
      };
      try {
        const data = await authApi(input_token, dataInput, apiUrl, token);
        if (data && data.success) {
          await Toastmessage(data.message, true);
          navigate('/location');
          editLocation(locationId);
        } else if (data && data.message === 'Token has expired') {
          setIsloading(false)
          dispatch(logout());
          localStorage.removeItem('token');
          await Toastmessage('Session expired. Redirecting to login...', false);
          navigate('/login');
        } else if (data === undefined) {
          setIsloading(false)
          await Toastmessage('No response from server', false);
        } else {
          setIsloading(false)
          await Toastmessage(data?.message || 'An error occurred', false);
        }
      } catch (error) {
        setIsloading(false)
        console.error("Error fetching data:", error);
        if (error.response && error.response.status === 401) {
          dispatch(logout());
          localStorage.removeItem('token');
          await Toastmessage('Session expired. Redirecting to login...', false);
          navigate('/login');
        } else {
          await Toastmessage('Something went wrong', false);
        }
      }

    };

    // Call the function to make the API call
    await fetchData();
  };

  const RequiredLabel = ({ children }) => (
    <>
      {children} <span style={{ color: 'red' }}>*</span>
    </>
  );

  return (

    <Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom='20px'
       backgroundColor='var(--theme-bg-light)'
        padding={2}
        borderRadius={1}
        className="title_head"
      >
        {/* Left Section */}
        <Box display="flex" alignItems="center">
          <MapPin style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
              <Typography fontSize={12} color="var(--text-color)">
            Edit Business location 
          </Typography>
        </Box>

        {/* Right Section */}
        <Button
          variant="outlined"
          component={Link}
          to="/location"
          sx={{
            backgroundColor: 'var(--back-button)',
            color: "var(--back-color)",
            fontWeight: 'bold',
            border: 'none',
            padding: '10px 20px'
          }}
          startIcon={<ChevronLeft sx={{ fontSize: 17 }} />}
          style={{ textTransform: 'none' }}
        >
          Back to Location List
        </Button>
      </Box>

      <Box className="card-box" sx={{ p: { xs: 2, sm: 2, md: 3 }, m:{ xs: 1, sm: 2, md: 3 }, border: '1px solid var(--border-color)', borderRadius: '8px' }}>
        <form onSubmit={handleSubmit}>

          <Box className="sub-header title_head">
            <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
                Edit Business Location
            </Typography>
            <FormControlLabel
              control={<Switch checked={active} onChange={handleActiveChange} />}
              label={
                <Typography sx={{ color: active ? 'green' : 'red', fontWeight: 'bold' }}>
                  Active : {active ? 'Yes' : 'No'}
                </Typography>
              }
            />
          </Box>
          <Grid container spacing={4} sx={{ mt: 2 }}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>Location Name</RequiredLabel></Typography>
              <TextField
                fullWidth
                placeholder="Enter the location name"
                variant="outlined"
                value={locationName}
                error={!!errors.locationName}
                helperText={errors.locationName} // Display error message
                InputProps={{
                  sx: {
                    borderRadius: '8px',
                  },
                }}
                onChange={(e) => setLocationName(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>Location Address</RequiredLabel></Typography>
              <TextField
                fullWidth
                placeholder="Enter the location address"
                variant="outlined"
                InputProps={{
                  sx: {
                    borderRadius: '8px',
                  },
                }}
                value={locationAddress}
                error={!!errors.locationAddress}
                helperText={errors.locationAddress} // Display error message
                onChange={(e) => setLocationAddress(e.target.value)}
              />
            </Grid>

            <Grid size={{ xs: 12,sm:6, md: 3 }}>
              <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>Country</RequiredLabel></Typography>
              <FormControl fullWidth>
                <Autocomplete
                  options={countryOptions}
                  getOptionLabel={(option) => option.name}
                  value={country}
                  disabled
                  onChange={(event, newValue) => setCountry(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select country"
                      variant="outlined"
                      error={!!errors.country}
                      helperText={errors.country} // Display error message
                      InputProps={{
                        ...params.InputProps,
                        sx: { borderRadius: '8px' },
                      }}
                    />
                  )}
                  sx={{ width: '100%' }}
                />
              </FormControl>
            </Grid>

            <Grid size={{ xs: 12,sm:6, md: 3 }}>
              <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>State</RequiredLabel></Typography>
              <FormControl fullWidth>
                <Autocomplete
                  options={stateOptions}
                  getOptionLabel={(option) => option.name}
                  value={state}
                  onChange={(event, newValue) => setState(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select state"
                      variant="outlined"
                      error={!!errors.state}
                      helperText={errors.state}
                      InputProps={{
                        ...params.InputProps,
                        sx: { borderRadius: '8px' },
                      }}
                    />
                  )}
                  sx={{ width: '100%' }}
                />
              </FormControl>
            </Grid>

            <Grid size={{ xs: 12,sm:6, md: 3 }}>
              <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>City</RequiredLabel></Typography>
              <TextField
                fullWidth
                placeholder="Enter the city"
                variant="outlined"
                value={city}
                error={!!errors.city}
                helperText={errors.city} // Display error message
                InputProps={{
                  sx: {
                    borderRadius: '8px',
                  },
                }}
                onChange={(e) => setCity(e.target.value)}
              />
            </Grid>


            <Grid size={{ xs: 12,sm:6, md: 3 }}>
              <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>Zip Code</RequiredLabel></Typography>
              <TextField
                fullWidth
                placeholder="Enter Zip code"
                variant="outlined"
                value={pinCode}
                error={!!errors.pinCode}
                helperText={errors.pinCode} // Display error message
                InputProps={{
                  sx: {
                    borderRadius: '8px',
                  },
                }}
                onChange={(e) => setPinCode(e.target.value)}
              />
            </Grid>

            <Grid size={12} sx={{ textAlign: 'center' }}>
              <Button
                type="submit"
                variant="contained"
                disabled={isLoading}  
                 className='btn-theme-button'
              >
                Update Location
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Box>


  );
};


